import { ChartUnit } from '../../model/chart-unit';
import { UI_STRINGS } from '../language/uistrings';

export function chartUnitToUIString(chartUnit: ChartUnit): string {
  switch (chartUnit) {
    case ChartUnit.undefined:
      return '';
    case ChartUnit.journeys:
      return UI_STRINGS.CHART_UNIT.JOURNEYS;
    case ChartUnit.tonnesCO2E:
      return UI_STRINGS.CHART_UNIT.TON_CO2E;
    case ChartUnit.kilotonnesCO2E:
      return UI_STRINGS.CHART_UNIT.KILOTON_CO2E;
    case ChartUnit.megatonnesCO2E:
      return UI_STRINGS.CHART_UNIT.MEGATON_CO2E;
    case ChartUnit.gigatonnesCO2E:
      return UI_STRINGS.CHART_UNIT.GIGATON_CO2E;
    case ChartUnit.hectares:
      return UI_STRINGS.CHART_UNIT.HECTARES;
    case ChartUnit.mills:
      return UI_STRINGS.CHART_UNIT.MILLS;
    case ChartUnit.tonnesCO2EUS:
      return UI_STRINGS.CHART_UNIT.TON_US_CO2E;
    case ChartUnit.kilotonnesCO2EUS:
      return UI_STRINGS.CHART_UNIT.KILOTON_US_CO2E;
    case ChartUnit.megatonnesCO2EUS:
      return UI_STRINGS.CHART_UNIT.MEGATON_US_CO2E;
    case ChartUnit.gigatonnesCO2EUS:
      return UI_STRINGS.CHART_UNIT.GIGATON_US_CO2E;
    default:
      return '';
  }
}
